<template>
  <v-card elevation="0" class="all-trade-tab account-history-tabs rounded-0" :color="$vuetify.theme.dark ? '#131c29' : '#E0EAF2'">
    <v-tabs :background-color="$vuetify.theme.dark ? '#131c29' : '#E0EAF2'">
      <v-tab class="pl-0 ml-0">
        <v-icon class="blink" color="#FF567F"> mdi-circle-small </v-icon>
        Live Trades
      </v-tab>
      <v-tab> History </v-tab>
      <v-tab> Summary </v-tab>
      <v-tab> Transaction </v-tab>

      <v-tab-item>
        <LiveTab></LiveTab>
      </v-tab-item>
      <v-tab-item>
        <HistoryTab></HistoryTab>
      </v-tab-item>
      <v-tab-item>
        <ChartTab></ChartTab>
      </v-tab-item>
      <v-tab-item>
        <TransactionTab></TransactionTab>
      </v-tab-item>

    </v-tabs>
  </v-card>
</template>
<script>
import ChartTab from './ChartTab';
import HistoryTab from './HistoryTab';
import LiveTab from './LiveTab';
import TransactionTab from './TransactionTab';

export default {
  components: {
    TransactionTab,
    LiveTab,
    HistoryTab,
    ChartTab,
  },
};
</script>

<style>
.live-details-page .account-history-tabs,
.live-details-page .account-history-tabs .v-tabs,
.live-details-page .account-history-tabs .v-tabs-bar,
.live-details-page .account-history-tabs .v-tabs-items,
.live-details-page .account-history-tabs .v-window-item,
.live-details-page .account-history-tabs .v-window-item > .v-card,
.live-details-page .account-history-tabs .v-window-item .v-card,
.live-details-page .account-history-tabs .v-window-item .v-sheet {
  color: var(--page-text) !important;
  background: var(--panel) !important;
  box-shadow: none !important;
}

.live-details-page .account-history-tabs .v-tabs-bar {
  height: 48px;
  padding: 0 20px;
  border-bottom: 1px solid var(--border);
}

.live-details-page .account-history-tabs .v-tab {
  min-width: 112px;
  color: var(--muted) !important;
  font-size: 12px;
  letter-spacing: 0;
  text-transform: none;
}

.live-details-page .account-history-tabs .v-tab--active,
.live-details-page .account-history-tabs .v-tab--active .v-icon {
  color: var(--gold) !important;
}

.live-details-page .account-history-tabs .v-tabs-slider {
  background: var(--gold) !important;
}

.live-details-page .account-history-tabs .v-window-item > .v-card > .row,
.live-details-page .account-history-tabs .v-window-item > div > .v-card > .row {
  margin: 0 !important;
}

.live-details-page .account-history-tabs .v-window-item .v-card.mt-6,
.live-details-page .account-history-tabs .chart-tab {
  margin-top: 0 !important;
  padding: 12px !important;
}

.live-details-page .account-history-tabs .transactionTable {
  padding-bottom: 0 !important;
  overflow: hidden;
  border: 1px solid var(--border);
  border-radius: 7px;
}

.live-details-page .account-history-tabs .v-data-table {
  color: var(--page-text) !important;
  background: var(--panel) !important;
}

.live-details-page .account-history-tabs .v-data-table-header,
.live-details-page .account-history-tabs .v-data-table-header tr,
.live-details-page .account-history-tabs .v-data-table-header th {
  background: var(--soft) !important;
}

.live-details-page .account-history-tabs .v-data-table th {
  height: 40px;
  color: var(--muted) !important;
  border-color: var(--border) !important;
  font-size: 10px;
  font-weight: 500;
}

.live-details-page .account-history-tabs .v-data-table td {
  height: 44px;
  color: var(--page-text) !important;
  background: var(--panel) !important;
  border-color: var(--border) !important;
  font-size: 11px;
}

.live-details-page .account-history-tabs .v-data-table tbody tr:hover td {
  background: rgba(217, 154, 0, 0.045) !important;
}

.live-details-page .account-history-tabs .profit-text-color {
  color: var(--gold) !important;
}

.live-details-page .account-history-tabs .text-gray {
  color: var(--gold) !important;
}

.live-details-page .account-history-tabs .v-data-footer {
  color: var(--muted) !important;
  background: var(--panel) !important;
  border-color: var(--border) !important;
}

.live-details-page .account-history-tabs .v-data-footer .v-icon {
  color: var(--gold) !important;
}

.live-details-page .account-history-tabs .custom-select .v-input__slot {
  color: var(--page-text) !important;
  background: var(--soft) !important;
  border: 1px solid var(--border);
  border-radius: 6px;
  box-shadow: none !important;
}

.live-details-page .account-history-tabs .custom-select .v-label,
.live-details-page .account-history-tabs .custom-select .v-select__selection {
  color: var(--page-text) !important;
}

.live-details-page .account-history-tabs .custom-select .v-icon,
.live-details-page .account-history-tabs .empty-trades-state .v-icon {
  color: var(--gold) !important;
}

.live-details-page .account-history-tabs .empty-trades-state span {
  color: var(--muted);
}

@media (max-width: 700px) {
  .live-details-page .account-history-tabs .v-tabs-bar { padding: 0; }
  .live-details-page .account-history-tabs .v-tab { min-width: 94px; }
}
</style>
